import React, { useEffect, useState } from "react";
import "./questionList.scss";
import { styled } from "@mui/material/styles";
import { connect } from "react-redux";
import LabelInput from "../../../atoms/label";
import QuestionOption from "../../../atoms/questionOption";
import {
  updateUserData,
  updateQuestionAnswer,
  getSiteSettingsApi,
} from "../../../redux/action/user";
import CheckRoundedIcon from "@mui/icons-material/CheckRounded";
import QuestionCheckBox from "../../../atoms/questionCheckBox";
import QuestionTextBox from "../../../atoms/questionTextBox";
import { Box, Modal } from "@mui/material";
import founderImage from "../../../assets/images/founders_image1.jpg";
import ButtonInput from "../../../atoms/button";

const NoShareTitle = styled("span")(() => ({
  display: "block",
  textAlign: "justify",
  fontWeight: "600",
}));

const NoShareFounderImage = styled("img")(() => ({
  width: "auto",
  maxWidth: "60%",
  objectFit: "cover",
  objectPosition: "top",
  imageRendering: "-webkit-optimize-contrast",
  marginTop: "10px",
  borderRadius: "7px",
}));

const isIntroEnabled = (value) =>
  !(value === false || value === "false" || value === 0 || value === "0");

const introDismissKey = () =>
  `beforeYouBeginDismissed:${localStorage.getItem("assesmentKey") || "current"}`;

const shouldOfferIntro = () =>
  localStorage.getItem("review") === null &&
  localStorage.getItem(introDismissKey()) !== "1";

const QuestionList = (props) => {
  let fleg = 1;
  const [introEnabled, setIntroEnabled] = useState(false);
  const [intro, setIntro] = useState(null);
  const [isNoDataShare, setIsNoDataShare] = useState(false);

  const dismissIntro = () => {
    localStorage.setItem(introDismissKey(), "1");
    setIsNoDataShare(false);
  };

  useEffect(() => {
    let cancelled = false;
    const offer = shouldOfferIntro();
    getSiteSettingsApi()
      .then((data) => {
        if (cancelled) return;
        const content = data?.assessmentBeforeYouBegin || null;
        const enabled = isIntroEnabled(
          content?.enabled ?? data?.assessmentBeforeYouBeginEnabled
        );
        setIntro(content);
        setIntroEnabled(enabled);
        if (enabled && offer) setIsNoDataShare(true);
      })
      .catch(() => {
        if (cancelled) return;
        setIntro(null);
        setIntroEnabled(true);
        if (offer) setIsNoDataShare(true);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <div
      id="questionList"
      className="questions-list"
      style={props.enableButton ? { pointerEvents: localStorage.getItem("review") ? "none" : "" } : {}}
    >
      {introEnabled && localStorage.getItem("review") === null && (
        <Modal
          open={isNoDataShare}
          onClose={dismissIntro}
        >
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: "550px",
              maxWidth: "75%",
              bgcolor: "#fff",
              border: "2px solid #fff",
              boxShadow: 24,
              borderRadius: "10px",
              p: 4,
            }}
          >
            <div className="no-share-modal">
              {(intro
                ? intro.title
                : props.user.language.questionList.no_sharing_modal.main_text1) && (
                <NoShareTitle>
                  {intro
                    ? intro.title
                    : props.user.language.questionList.no_sharing_modal.main_text1}
                </NoShareTitle>
              )}
              <ul>
                {(Array.isArray(intro?.bullets)
                  ? intro.bullets
                  : [
                      props.user.language.questionList.no_sharing_modal.main_text2,
                      props.user.language.questionList.no_sharing_modal.main_text3,
                      props.user.language.questionList.no_sharing_modal.main_text4,
                      props.user.language.questionList.no_sharing_modal.main_text5,
                    ]
                ).map((line, index) => (
                  <li key={`${index}-${line}`}>{line}</li>
                ))}
              </ul>
              {intro?.signature ? (
                <p className="no-share-modal__signature">{intro.signature}</p>
              ) : null}
            </div>
            <div>
              <div
                style={{
                  display: "flex",
                }}
              >
                {intro?.showImage !== false && (
                  <NoShareFounderImage src={intro?.imageUrl || founderImage} alt="" />
                )}
                <ButtonInput
                  class={`questions-list__modal_next`}
                  text={
                    intro?.buttonLabel ||
                    props.user.language.questionList.no_sharing_modal.next
                  }
                  style={{
                    padding: "4px 20px !important",
                  }}
                  onSubmit={dismissIntro}
                />
              </div>
            </div>
          </Box>
        </Modal>
      )}
      {props.questionList.map((mainObj, index) => {
        return (
          <div key={index}>
            <div id={`questionIndex${index}`}>
              {mainObj.DisplayOrder <= props.questionIndex && (
                <div>
                  <div
                    id={`questionList${index}`}
                    className={`questions-list__question margin-top-20 ${mainObj.DisplayOrder === props.questionIndex
                      ? "questions-list__question__active"
                      : ""
                      }`}
                  >
                    <div className="questions-list__question--main">
                      <div className="questions-list__question--main--count ">
                        <LabelInput
                          style={{ color: "#fff" }}
                          className="question-title"
                          text={`${fleg++}.`}
                        />
                      </div>
                      <div className="questions-list__question--main--question">
                        <LabelInput
                          style={{ color: "#fff" }}
                          className="break-text question-title font-transform"
                          // requireField={subObj.isMandatory === '1' ? true : false}
                          text={mainObj.QuestionText}
                        />
                        {mainObj.QuestionType === "Single" ? (
                          <QuestionOption
                            answerIndex={index}
                            option={mainObj.options}
                            questionIndex={mainObj.userQuestionID}
                            defaultValue={mainObj.Response[0]}
                            displayOrder={mainObj.DisplayOrder}
                            valueChange={props.valueChange}
                          />
                        ) : mainObj.QuestionType === "Multi" ? (
                          <div>
                            <QuestionCheckBox
                              answerIndex={index}
                              option={mainObj.options}
                              questionIndex={mainObj.userQuestionID}
                              defaultValue={mainObj.Response}
                              displayOrder={mainObj.DisplayOrder}
                              valueChange={props.valueChange}
                            />
                          </div>
                        ) : mainObj.QuestionType === "Text" ? (
                          <QuestionTextBox
                            answerIndex={index}
                            option={mainObj.options}
                            displayOrder={mainObj.DisplayOrder}
                            questionIndex={mainObj.userQuestionID}
                            type={"text"}
                            defaultValue={mainObj.Response}
                            valueChange={props.valueChange}
                            placeholder={
                              props.user.language?.questionList
                                ?.textboxPlaceholder
                            }
                            buttonText={
                              props.user.language?.questionList
                                ?.textboxButtonText
                            }
                          />
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
            {props.showCongFleg === mainObj.DisplayOrder && (
              <div className="congrats-block margin-top-20">
                <div className="congrats-block__left-side">
                  <CheckRoundedIcon style={{ color: "#fff" }} />
                </div>
                <div className="congrats-block__right-side">
                  {props.questionList.find(
                    (subObj) => subObj.DisplayOrder === props.showCongFleg
                  )?.SuccessMessage ? (
                    <h3>
                      {
                        props.questionList.find(
                          (subObj) =>
                            subObj.DisplayOrder === props.showCongFleg
                        )?.SuccessMessage
                      }
                    </h3>
                  ) : (
                    <>
                      <h3>
                        Completed{" "}
                        {
                          props.questionList.find(
                            (subObj) =>
                              subObj.DisplayOrder === props.showCongFleg
                          )?.Determinant
                        }
                        .
                      </h3>
                      {/* <p>
                        Section to reveal how to manage your exposure to
                        environmental, nutritional and emotional toxins.
                      </p> */}
                    </>
                  )}
                </div>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

QuestionList.propTypes = {};
QuestionList.defaultProps = {};

const actionCreators = {
  updateUserData,
  updateQuestionAnswer,
};

export default connect(
  ({ user }) => ({
    user,
  }),
  actionCreators
)(QuestionList);
